// Import react.
import * as React from 'react';
// Import contexts.
import {
	EndorsementContext,
} from '@app/contexts';

export const useEndorsementContext = () => React.useContext(EndorsementContext);